import { player } from "./selectors"

export const isPresentation = () => {
  return player.hasClass("presentation-player")
}

export const isDocument = () => {
  return player.hasClass("document-player")
}

export const isInfographic = () => {
  return player.hasClass("infographic-player")
}

export const isEmbed = () => {
  return player.hasClass("embed")
}
